<template>
  <b-modal
    id="arquivo-view"
    ref="arquivo"
    no-close-on-esc
    hide-footer
    hide-header
    size="xl"
    class="file-modal m-0"
    content-class="modal-arquivo"
  >
    <div style="height: 90%;">
      <b-button
        class="close close-file"
        variant="none"
        @click.stop="fechar()"
      >
        <span aria-hidden="true">&times;</span>
      </b-button>
      <div
        class="mx-5 my-2"
        :class="{'image-wrapper':isImage && !isVideo, 'pdf-wrapper': !isImage && !isVideo, 'video-wrapper': isVideo && !isImage}"
      >
        <embed
          v-if="isImage && !isVideo"
          style="max-width:100%; max-height:90vh"
          :class="{'image-download': download}"
          :src="url"
        >
        <div
          v-else-if="arquivoSemVisualizacao || videoNaoSuportado"
          class="sem-visualizacao"
          :class="{'image-download': download}"
        >
          <div class="mensagem-visualizacao">
            <span>Clique em "Fazer download" para baixar o arquivo!</span>
          </div>
        </div>
        <iframe
          v-else-if="!isImage && !isVideo"
          :src="pdfUrl"
          frameborder="0"
          height="100%"
          width="100%"
        />
        <video
          v-else-if="!isImage && isVideo"
          width="100%"
          height="100%"
          controls
        >
          <source
            :src="url"
          >
        </video>
        <!-- sandbox="allow-top-navigation" -->
        <div :class="['rodape',{'mt-1':isImage}]">
          <span v-if="observacao !== ''">
            <strong>Observação:&nbsp;</strong>{{ observacao }}
          </span>
          <br>
          <div
            class="mt-1"
            style="font-size:14.5px"
          >
            <font-awesome-icon
              :icon="faDownload"
              class="mr-2"
            />
            <span>
              <a
                :href="url"
                :download="url"
                target="_blank"
                @click.stop
              >Fazer download</a></span>
          </div>
        </div>

      </div>
    </div>
  </b-modal>
</template>

<style lang="scss">
#arquivo-view .modal-xl {
  height: calc(100vh - 6%);
  width: calc(95vw);
}

.modal-arquivo {
  background-color: inherit;
  height: 100%;

  .pdf-wrapper {
    vertical-align: middle;
    height: 90%;
    & .close-file {
      margin-top: 0 !important;
    }
  }

  .image-wrapper {
    height: 90%;
    vertical-align: middle;
  }

  .video-wrapper {
    height: 90%;
    max-height: 85vh !important;
  }

  .close-file {
    background: transparent;
    color: #fff !important;
    font-size: 3rem;
    position: absolute;
    right: 1rem;
    top: 0.5rem;
    font-weight: bold;
    border-radius: 80px;
    background-color: black;
    width: 45px;
    opacity: 0.7;
  }

  .rodape {
    color: #fff;
    font-size: 15px;
    text-align: center;
    width: 80%;
    border-radius: 4px;
    background-color: rgb(0 0 0 / 60%);
    padding: 0.3rem;
    margin: auto;
    margin-top: 0.5rem;

    & a {
      text-decoration: underline;
      color: #fff;
      cursor: pointer;
    }
  }

  .image-download {
    max-height: 85vh !important;
  }
  .pdf-download {
    height: 55% !important;
  }
}

.sem-visualizacao{
  background-color: #ededed;
  height: 100%;

  & div{
    text-align: center;
    width: 100%;
    height: 100%;
    padding-top: calc(20%);
    & span{
      background-color: #4c494c;
      border-radius: 12px;
      color: #fff;
      padding: 20px;
      text-align: center;
      box-shadow: 0px 10px 12px 5px rgb(0 0 0 / 20%);
      font-size: 19px;
      line-height: 27px;
    }
  }
}
</style>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faDownload,
} from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'VisualizarArquivo',
  components: {
    FontAwesomeIcon,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    observacao: {
      type: String,
      default: '',
    },
    download: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faDownload,
      arquivoSemVisualizacao: false,
      videoNaoSuportado: false,
    }
  },
  computed: {
    pdfUrl() {
      if (this.arquivoSemVisualizacao) {
        return ''
      }
      return `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(this.url)}&embedded=true`
    },
    isImage() {
      if (this.url.toLowerCase().includes('.png') || this.url.toLowerCase().includes('.jpg')) {
        return true
      }
      return false
    },
    isVideo() {
      if (this.url.toLowerCase().includes('.mp4') || this.url.toLowerCase().includes('.webm') || this.url.toLowerCase().includes('.wmv')) {
        return true
      }
      return false
    },
  },
  created() {
    this.$nextTick(() => {
      this.arquivoSemVisualizacao = this.url.toLowerCase().includes('.zip') || this.url.toLowerCase().includes('.rar')
      this.videoNaoSuportado = this.url.toLowerCase().includes('.wmv')
      this.show()
    })
  },
  methods: {
    show() {
      this.$refs.arquivo.show()
    },
    fechar() {
      this.$refs.arquivo.hide()
      this.$emit('hidden')
    },
  },
}
</script>
